<template>
	<v-menu
		bottom
		min-width="200px"
		rounded
		offset-y
		left
	>
		<template v-slot:activator="{ on }">
			<v-btn
				v-on="on"
				text
				elevation="0"
				plain
				small
				color="grey"
				:ripple="false"
				class="mw-auto pa-0"
				:loading="loading"
			>
				<v-icon size="16px">mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-card class="d-flex flex-column py-2">
			<template v-for="(option, i) in options">
				<post-dropdown-button
					v-if="option.display || option.display === undefined"
					:text="option.text"
					:icon="option.icon"
					:action="option.action"
					v-bind:key="'filter-' + i"
					:small="small"
				/>
			</template>
		</v-card>
	</v-menu>
</template>

<script>
import PostDropdownButton from "@/components/wall/post/PostDropdownButton";
export default {
	name: "PostDropdown",
	components: {
		PostDropdownButton
	},
	props: {
		options: {
			type: Array,
			required: true
		},
		loading: {
			type: Boolean,
			required: false,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		}
	},
}
</script>
